import { createElemPropsHook, useForkRef } from '@workday/canvas-kit-react/common';
import { usePopupModel } from './usePopupModel';
import React from 'react';
/**
 * Hooks a Popper up to a PopupModel
 */
export var usePopupPopper = createElemPropsHook(usePopupModel)(function (_a, ref) {
    var state = _a.state, events = _a.events;
    var elementRef = useForkRef(ref, state.stackRef);
    var onPlacementChange = React.useCallback(function (placement) {
        if (placement !== state.placement) {
            // only update if the placement has changed
            events.updatePlacement({ placement: placement });
        }
    }, [events, state.placement]);
    return {
        open: state.visibility !== 'hidden',
        anchorElement: state.targetRef,
        ref: elementRef,
        onPlacementChange: onPlacementChange,
    };
});
